import React, { useState, ChangeEvent } from 'react';
import styles from './range-input.module.scss';

interface RangeInputProps {
  min?: number;
  max?: number;
  initialValue: number;
  onChange: (value: number) => void;
}

export const RangeInput: React.FC<RangeInputProps> = ({
  min = 1,
  max = 12,
  initialValue,
  onChange,
}) => {
  const [value, setValue] = useState<number>(initialValue);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(e.target.value);
    setValue(newValue);
    onChange(newValue);
  };
  const thumbWidth = 15;
  const progress = ((value - min) / (max - min)) * 100;
  const leftPosition = `calc(${progress}% + ${(0.5 - progress / 100) * thumbWidth}px)`;
  return (
    <div className={styles.slider__container}>
      {/* Обертка для позиционирования числа */}
      <div className={styles.slider__body}>
        <div className={styles.slider__value} style={{ left: leftPosition }}>
          {value}
        </div>

        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          className={styles.slider__input}
          style={{ '--progress': `${progress}%` } as React.CSSProperties}
        />
      </div>

      <div className={styles.slider__labels}>
        <span>{min}</span>
        <span>{max}</span>
      </div>
    </div>
  );
};
